import { PriceBookAccountingCodeModel, PriceModel } from "./price-book.model";
import { Attachment } from "./material-item.model";
import { CodeTypeModel } from "../code-type.model";
import { GridDataResult } from "@progress/kendo-angular-grid";

export class SaItemModel {
    ID: string
    ItemNumber: string
    IsFrequentlyUsed: boolean
    Description: string
    Category: { ID: string }
    AccountingCode: PriceBookAccountingCodeModel
    Note: string
    StandardCost: string
    IsDescriptionEditAllowed: boolean
    IsTaxable: boolean
    Prices: PriceModel[]
    Length: number;
    DurationType: CodeTypeModel
    IntervalType: CodeTypeModel
    IntervalTypeID: string
    ServiceAgreementCategories: any[]
    FeaturesAndBenefits: string
    Discount: number
    IsActive: boolean
    Attachments: any[];
    ModifyDate: string;
    PriceBookItem: any; //Model must be created later

    public constructor() {
        this.Attachments = [];
        //this.Discount = 0;
        this.DurationType = new CodeTypeModel();
        this.FeaturesAndBenefits = '';
        this.ID = "";
        this.IntervalType = new CodeTypeModel();
        this.IntervalTypeID="";
        this.IsFrequentlyUsed = false;
        this.ItemNumber = "";
        this.ModifyDate = "";
        this.Prices = [];
        this.ServiceAgreementCategories = [];
    }
}
